import { jsx as a } from "react/jsx-runtime";
import t from "classnames";
import * as s from "react";
import { scroll as c, noScrollbar as m } from "./horizontal-scroll.css-mistica.js";
const n = /*#__PURE__*/ s.forwardRef((param, l)=>/* @__PURE__ */ {
    let { children: o , noScrollbar: r  } = param;
    return a("div", {
        className: t(c, {
            [m]: r
        }),
        ref: l,
        children: o
    });
}), p = n;
export { p as default };
